export default __webpack_public_path__ + "static/Plots0001-30c1f4587afec83fb4898b30acdf61eb.jpg";